// Import Core
import React, { useState } from "react";
import styled from "styled-components";
// Import Assets
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const FilterDropdownStyling = styled.div`
  -webkit-tap-highlight-color: transparent !important;
  &:focus,
  &:visited,
  &:active {
    outline: none !important;
  }
  padding: 20px 0;
  border-top: 1px solid var(--neutral-25);
  border-top: 1px solid var(--neutral-25);
  width: 100%;
  cursor: pointer;
  @media (max-width: 768px) {
    padding: 16px 0;
  }
  &:last-child {
    border-bottom: 1px solid var(--neutral-25);
    padding-bottom: 20px;
  }
  .accordion-title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    h5 {
      text-transform: uppercase;
    }
    svg {
      width: 20px;
      height: 100%;
      color: var(--black);
    }
  }
  .accordion-content {
    scrollbar-width: thin;
    scrollbar-color: var(--red) var(--neutral-5);
    &::-webkit-scrollbar {
      display: none !important;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: fit-content;
    max-height: 200px;
    overflow-y: auto;
    @media (max-width: 992px) {
      max-height: unset;
      overflow-y: auto;
    }
    .accordion-checkbox {
      display: flex;
      padding: 8px 0px;
      align-items: center;
      gap: 12px;
      width: 100%;
      &:active {
        outline: none;
        border: none;
      }
    }
    .option-name {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
`;

const FilterDropdown = ({
  label,
  options,
  counts,
  selectedOptions,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen((prev) => !prev);

  return (
    <FilterDropdownStyling className="accordion-item">
      <div className="accordion-title" onClick={toggleDropdown}>
        <h5 className="tk-trajan-pro-3">{label}</h5>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      {isOpen && (
        <div className="accordion-content">
          {options.map((option) => (
            <label key={option} className="accordion-checkbox">
              <input
                type="checkbox"
                id={option}
                checked={selectedOptions.includes(option.toLowerCase())}
                onChange={() => onChange(option)}
              />
              <div className="option-name">
                <span>{option}</span>
                <span>{counts[option] ? ` (${counts[option]})` : ""}</span>
              </div>
            </label>
          ))}
        </div>
      )}
    </FilterDropdownStyling>
  );
};

export default FilterDropdown;
